module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/logo-coj-en-abdcb2eb903b6c3f801bcfbcb3cceb46.svg";